/**
 * Action kind: explore.
 *
 * A template with variants cannot be added to the cart until size/colour are
 * picked. This is the card's INITIAL state for one — grid.js's own swatch/
 * size click handler (variant_resolver.js) resolves a selection into a real
 * item_code and patches the actions slot over to cart.js's Add to Cart
 * rendering, in place, once a buyable match is found. This link stays the
 * fallback path: JS failure, no swatches on the model, or a shopper who
 * ignores the pills and clicks straight through, all still land on the PDP
 * to pick there instead.
 */

import { el } from '../../dom.js';

export function render(model) {
	return el('a', { href: model.actions.exploreHref || model.href }, [
		el('div', {
			class: 'btn btn-sm btn-explore-variants w-100 mt-4 rfhq-pc-cta rfhq-pc-cta--outline',
			text: model.actions.exploreLabel || 'Explore',
		}),
	]);
}
